module.exports = __webpack_public_path__ + "static/media/CH.570f0c2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/CH.svg
// module id = 223
// module chunks = 0